// Base for all request paths; repositories and MSW handlers build off it to avoid drift.
export const API_PREFIX = "/api/v1";
